import React from 'react';
import classNames from 'classnames';
import styles from './GA2RFValuesTableHead.module.css';

function GA2RFValuesTableHead({ className, style, children }) {
  return (
    <div className={classNames(styles.root, 'rt-thead', className)} style={style}>
      {children}
    </div>
  );
}

export default GA2RFValuesTableHead;
